import { createSlice } from "@reduxjs/toolkit";

export const serviceSlice = createSlice({
  name: "serviceInformation",
  initialState: {
    services: [],
    subCategories: [],
  },
  reducers: {
    setServices: (state, action) => {
      state.services = action.payload || [];
    },
    setSubCategories: (state, action) => {
      state.subCategories = action.payload || [];
    },
  },
});

export const { setServices, setSubCategories } = serviceSlice.actions;

export const selectServices = (state) => state?.serviceInfo?.services || [];
export const selectSubCategories = (state) => state?.serviceInfo?.subCategories || [];

export default serviceSlice.reducer;

